import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class AffiliationMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.affiliation.affiliationMapperError"));

        Object.setPrototypeOf(this, AffiliationMapperError.prototype);
    }
}